module.exports = __webpack_public_path__ + "img/logo_multicare.871cad5c.svg";